import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LiveMatchList from './components/LiveMatchList';
import NewsSection from './components/NewsSection';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '米乐体育',
  url: 'https://www.milesports.com',
  description: '米乐体育是专业体育赛事平台，汇聚全球顶级赛事直播、体育竞技、数据分析与互动娱乐。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-6666',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
  sameAs: [
    'https://www.milesports.com',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '米乐体育',
  url: 'https://www.milesports.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.milesports.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="米乐体育 - 官方正品体育平台，赛事直播与竞技娱乐一站式体验"
        description="米乐体育是专业体育赛事平台，汇聚全球顶级赛事直播、体育竞技、数据分析与互动娱乐。米乐体育为用户提供流畅稳定的观赛体验，多端同步、安全可靠，立即注册享受专属体育娱乐服务。"
        keywords="米乐体育,米乐体育官网,米乐体育平台,米乐体育直播,米乐体育赛事,米乐体育注册,米乐体育app下载"
        canonicalUrl="/"
        ogImage="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20panorama%20with%20golden%20red%20lighting%2C%20epic%20scale%2C%20professional%20sports%20broadcast%20aesthetic%2C%20cinematic%20atmosphere%2C%20powerful%20typography%20background%20for%20MileSports%20branding&width=1200&height=630&seq=og-homepage&orientation=landscape"
        jsonLd={[organizationSchema, websiteSchema]}
      />
      <main>
        <HeroSection />
        <CategoryGrid />
        <LiveMatchList />
        <NewsSection />
        <StatsSection />
        <FAQSection />
      </main>
    </>
  );
}